import { GroupRow } from "./GroupRow";
import { useDispatch } from "react-redux";
import { openSideDrawer } from "../../../../../utils/permissionSlice";
import { fetchManagePermissionGroup } from "../../../../../utils/api/managePermissionApi";
import { useEffect, useState } from "react";
import { pushAlert } from "../../../../../utils/alertSlice";
import { checkAccessPermission } from "../../../../../utils/utilityFunctions/localServices";

export function PermissionsTable({ refetch, setRefetch }) {
  const dispatch = useDispatch();

  const [groups, setGroups] = useState([]);
  const [groupNameSearch, setGroupNameSearch] = useState("");

  const getGroupPermissionData = async () => {
    try {
      const response = await fetchManagePermissionGroup({ query: { key: "all_groups" } });
      if (response?.success) {
        setGroups(response?.data);
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "danger" }));
      }
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message, type: "danger" }));
    }
  };

  const handleAddUser = () => {
    dispatch(openSideDrawer({ key: "CREATE_USER", data: {} }));
  };

  const handleAddGroup = () => {
    dispatch(openSideDrawer({ key: "CREATE_GROUP", data: {} }));
  };

  useEffect(() => {
    getGroupPermissionData();
  }, [refetch]);

  return (
    <div className="mt-2 h-full flex flex-col max-md:mt-8 max-md:max-w-full">
      {/* Heading and description */}
      <div className="w-full max-md:max-w-full">
        <h2 className="text-lg font-medium tracking-wide text-primary max-md:max-w-full">Group or User Permissions</h2>
        <p className="mt-2 text-sm text-neutral-500">
          Manage access levels and permissions for your company information
        </p>

        {/* Search and action buttons */}
        <div className="flex flex-wrap gap-6 justify-between items-end mt-4 w-full max-md:max-w-full">
          <div className="flex gap-2 items-center px-2 py-1 text-sm rounded-md border border-gray-200 min-h-[39px] min-w-60 text-neutral-500 w-[300px]">
            <img
              src="https://api.builder.io/api/v1/image/assets/TEMP/dac71522aa23d67d26ac9a353012590c427bbd43?placeholderIfAbsent=true&apiKey=461dd38d56414be9bb1e394424980cc1"
              className="object-contain aspect-square w-[18px]"
              alt="Search"
            />
            <input
              type="text"
              placeholder="Search by Group Name"
              className="bg-transparent border-none outline-none flex-1 text-sm"
              onChange={(e) => setGroupNameSearch(e.target.value)}
            />
          </div>
          <div className="flex text-base font-medium text-cyan-900">
            {/* <button
              onClick={handleAddUser}
              className="flex gap-2.5 items-center px-6 py-3 bg-white rounded-md border border-cyan-900"
            >
              Add User
            </button> */}
            {checkAccessPermission("Add & Manage Groups & Permission") && (
              <button
                onClick={handleAddGroup}
                className="flex gap-2.5 items-center px-4 py-2 bg-white rounded-md border border-cyan-900"
              >
                + Add Group
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Table section */}
      <div className="mt-6 w-full rounded-md border border-gray-200 bg-white max-md:max-w-full overflow-x-auto p-4">
        <GroupRow groups={groups} groupNameSearch={groupNameSearch} />
      </div>
    </div>
  );
}
